import showModalNotificationError from '@v2/commons/modals/ModalNotification/showModalNotificationError'

export const handleMutationError = (err: any, defaultMessage: string) => {
  let errorMessage = err?.data?.message || err?.data?.error || defaultMessage
  if (Array.isArray(errorMessage)) {
    errorMessage = errorMessage.join(', ')
  }
  showModalNotificationError({
    subtitle: errorMessage,
  })
  return false
}
